export default {
  allowVideoFile: true,
  videoFileAutoplay: true,
  videoFileMuted: false,
  controlType: 'audio'
};